module.exports = __webpack_public_path__ + "static/media/image_14.036cb8b0.png";